import CreateRentButton from './CreateRentButton'
export default CreateRentButton
